import React, { useEffect, useState } from "react";

// Component that randomly displays one child based on probability weights
export const RandomDisplay = ({
  children,
  weights = [],
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    selectRandomChild();
  }, []);

  const selectRandomChild = () => {
    const childArray = React.Children.toArray(children);

    // Use equal weights if not provided
    const finalWeights =
      weights.length === childArray.length ? weights : childArray.map(() => 1);

    // Calculate total weight
    const totalWeight = finalWeights.reduce((sum, w) => sum + w, 0);

    // Generate random number
    let random = Math.random() * totalWeight;

    // Select child based on weighted probability
    for (let i = 0; i < finalWeights.length; i++) {
      random -= finalWeights[i];
      if (random <= 0) {
        setSelectedIndex(i);
        return;
      }
    }
  };

  const childArray = React.Children.toArray(children);

  if (childArray.length === 0) {
    return null;
  }

  return childArray[selectedIndex];
};